import type { ExcursionPage } from "../slug-excursions";
import laturbie from "@/assets/images/excursions/destinations/laturbie.jpeg";

const page: ExcursionPage = {
  slug: "eze-la-turbie",
  hero: {
    title: "Excursion Èze – La Turbie",
    subtitle: "Villages perchés, vues panoramiques et parfum de Méditerranée.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: laturbie,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Èze : village perché et jardin exotique" },
      { text: "La Turbie : Trophée des Alpes et vues mer" },
      { text: "Routes panoramiques de la Grande Corniche" },
      { text: "Arrêts photos surplombant la Méditerranée" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      {
        title: "Èze",
        description: "Montée au jardin, ruelles, parfumerie (option)",
      },
      {
        title: "La Turbie",
        description: "Centre, Trophée d’Auguste (extérieur)",
      },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "4 à 6 heures" },
      { label: "Départ", value: "Cannes" },
      { label: "Dénivelé", value: "Quelques passages en pente/escaliers" },
      { label: "Billets jardin", value: "Entrée jardin exotique non incluse" },
    ],
  },
};

export default page;
